import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function DoseCalculator({ classes, unit }) {
  const [lastDose, setLastDose] = useState('');
  const [daysSinceLastDose, setDaysSinceLastDose] = useState('');
  const [desiredDose, setDesiredDose] = useState('');
  const [result, setResult] = useState(''); // Initial state is an empty string

  useEffect(() => {
    const calculate = () => {
      const lastDoseValue = parseFloat(lastDose);
      const daysSinceLastDoseValue = parseFloat(daysSinceLastDose);
      const desiredDoseValue = parseFloat(desiredDose);

      // Return an empty string if any input is invalid
      if (isNaN(lastDoseValue) || isNaN(daysSinceLastDoseValue) || isNaN(desiredDoseValue)) return '';

      // Calculation based on provided formula
      const estimatedDosage = (desiredDoseValue / 100) * 280.059565 * Math.pow(daysSinceLastDoseValue, -0.412565956);
      const newAmount = Math.max(lastDoseValue, estimatedDosage);
      const roundedResult = Math.round(newAmount * 10) / 10;

      return `${roundedResult} ${unit}`;
    };

    setResult(calculate());
  }, [lastDose, daysSinceLastDose, desiredDose, unit]);

  return (
    <div>
      <div style={{ marginBottom: '15px', marginTop: '20px'}}>
        <label style={{ }}>
          Last dose:
          <input
            type="number"
            value={lastDose}
            onChange={(e) => setLastDose(e.target.value)}
            style={{ marginLeft: '20px', width: '80px' }}
          />
        </label>
        <span style={{ marginLeft: '5px' }}>{unit}</span>
      </div>
      <div style={{ marginBottom: '15px', alignItems: 'center' }}>
  <label style={{ flex: '1' }}>
    Days since last dose:
  </label>
  <input
    type="number"
    value={daysSinceLastDose}
    onChange={(e) => setDaysSinceLastDose(e.target.value)}
    style={{ marginLeft: '20px', width: '60px' }} // Adjust width as needed
  />
</div>
      <div style={{ marginBottom: '5px'}}>
        <label style={{ flex: '1' }}>
          Desired dose:
          <input
            type="number"
            value={desiredDose}
            onChange={(e) => setDesiredDose(e.target.value)}
            style={{ marginLeft: '20px', width: '80px' }}
          />
        </label>
        <span style={{ marginLeft: '5px' }}>{unit}</span>
      </div>
      <div style={{ margin: '20px 0px'}}>
        <strong>
          {result ? `${result} will produce similar effects` : 'Calculate the tolerance-dose effect'}
        </strong>
      </div>
    </div>
  );
}

DoseCalculator.propTypes = {
  classes: PropTypes.object, // Assuming classes is an object, but you can adjust the type
  unit: PropTypes.string.isRequired, // Added unit as a required prop
};

export default DoseCalculator;
